
import { mapActions, mapGetters, mapState } from 'vuex';
import { getThemedCSSVars } from '../../utils';
import NudgeContents from './NudgeContents.vue';

export default {
  components: {
    NudgeContents
  },

  data() {
    return {
      timer: null
    }
  },

  computed: {
    ...mapState('chatbotStore', ['triggeredConversation', 'isOpen']),

    ...mapGetters('chatbotStore', ['ampConfig', 'currentAmpId', 'getAmpById', 'currentConversationId']),

    ampName() {
      const ampId = this.triggeredConversation?.ampId;

      if (this.currentAmpId !== ampId) {
        return this.getAmpById(ampId).name;
      }

      return this.ampConfig.name;
    },

    cssVars() {
      return getThemedCSSVars(this.ampConfig);
    },
  },

  watch: {
    isOpen(opened) {
      if(!opened) clearTimeout(this.timer);
      else this.setTimer();
    },

    triggeredConversation(newConv, oldConv) {
      if (newConv?.id !== oldConv?.id) {
        const { progress } = this.$refs;

        // restart the progress bar fill animation
        progress.classList.remove('progress-bar-fill');
        // eslint-disable-next-line
        progress.offsetWidth; // trigger a DOM reflow
        progress.classList.add('progress-bar-fill');

        this.setTimer();
      }
    }
  },

   mounted() {
    this.setTimer();
  },

  destroyed() {
    clearTimeout(this.timer);
  },

  methods: {
    ...mapActions('chatbotStore', ['setNudgeState', 'setTriggeredConversation', 'goToAmp', 'setAmpSetupOptions']),

    onClose() {
      this.setNudgeState(false);
    },

    onRedirect() {
      this.setNudgeState(false);

      const { ampId, id: conversationId } = this.triggeredConversation || {};
      const changeConversationEvent = {
        conversationId,
        prevConversationId: this.currentConversationId ?? '',
        changeEvent: 'NUDGE'
      }

      if (this.currentAmpId !== ampId) {
        this.setAmpSetupOptions({ conversationId, ampId });
        this.goToAmp(ampId);
      } else {
        this.$chatbotService.runConversation(conversationId);
      }

      this.setTriggeredConversation(null);
      this.$tracking?.sendResponseEvent('conversationChange', changeConversationEvent);
    },

    setTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.setNudgeState(false), 20000);
    }
  },
};
